import { useMutation, useQuery } from "@tanstack/react-query";
import AkioService from "services/AkioService";

export const useGetConfiguration = (refererId, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getConfiguration", refererId],
    queryFn: () => AkioService.getConfiguration(refererId),
    enabled: !!refererId,
    retry: false,
    ...queryOptions,
  });
};

export const useGetAvailability = (refererId, conditionUuids, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getAvailability", refererId, conditionUuids],
    queryFn: () => AkioService.getAvailability(refererId, conditionUuids),
    enabled: !!refererId && !!conditionUuids,
    retry: false,
    ...queryOptions,
  });
};

export const useGetCalendar = (refererId, conditionUuids, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getCalendar", refererId, conditionUuids],
    queryFn: () => AkioService.getCalendar(refererId, conditionUuids),
    enabled: !!refererId && !!conditionUuids,
    retry: false,
    ...queryOptions,
  });
};

export const useWebcallback = (config) => {
  return useMutation({
    ...(config || {}),
    mutationFn: AkioService.webcallback,
  });
};
